/**
 * Shared constants used across web and mobile frontends.
 */

/**
 * Well-known UUID for the FamilyPal AI assistant bot user.
 * Messages with this sender ID are from the AI agent invoked via @familypal mentions.
 */
export const FAMILYPAL_BOT_USER_ID = '00000000-0000-0000-0000-000066616d70';

/**
 * Display name for the FamilyPal AI assistant in chat.
 */
export const FAMILYPAL_BOT_DISPLAY_NAME = 'FamilyPal AI';

/**
 * Check whether a given user/sender ID belongs to the FamilyPal bot.
 */
export function isBotMessage(senderId: string): boolean {
  return senderId === FAMILYPAL_BOT_USER_ID;
}
